import { render, staticRenderFns } from "./EmptyQuestionnaire.vue?vue&type=template&id=7183e690&scoped=true&"
var script = {}
import style0 from "./EmptyQuestionnaire.vue?vue&type=style&index=0&id=7183e690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7183e690",
  null
  
)

export default component.exports